import React, {useState} from 'react'
import styles from '../css/EditExercise.module.css'
import Axios from '../../Axios/Axios'
import EditReasons from './EditReasons'
import EditPerTargetLimits from './EditPerTargetLimits'
import EditColumnOrder from './EditColumnOrder'
import Popup from '../../PopupWindow/Popup'

function EditExercise(props) {

    const [name, setName] = useState(props.data.NAME || "")
    const [team, setTeam] = useState(props.data.TEAM || "")
    const [startDate, setStartDate] = useState(props.data.START_DATE || "")
    const [endDate, setEndDate] = useState(props.data.END_DATE || "")
    const [maxChangesPerTerritory, setMaxChangesPerTerritory] = useState(props.data.MAX_CHANGES_PER_TERRITORY || 0)
    const [minChangesPerTerritory, setMinChangesPerTerritory] = useState(props.data.MIN_CHANGES_PER_TERRITORY || 0)
    const [maxCallsPerTerritory, setMaxCallsPerTerritory] = useState(props.data.MAX_CALLS_PER_TERRITORY || 0)
    const [minCallsPerTerritory, setMinCallsPerTerritory] = useState(props.data.MIN_CALLS_PER_TERRITORY || 0)
    const [maxUpgradesPerTerritory, setMaxUpgradesPerTerritory] = useState(props.data.MAX_UPGRADES_PER_TERRITORY || 0)
    const [maxDowngradesPerTerritory, setMaxDowngradesPerTerritory] = useState(props.data.MAX_DOWNGRADES_PER_TERRITORY || 0)
    const [limitType, setLimitType] = useState(props.data.LIMIT_TYPE ?? 'percent')
    const [editReasons, setEditReasons] = useState()
    const [editPerTargetLimits, setEditPerTargetLimits] = useState()
    const [editColumnOrder, setEditColumnOrder] = useState()

    const [wiggle, setWiggle] = useState(false)
    const [valid, setValid] = useState(true)

    return (
        <div className={styles.editScreen}>
            <div className={styles.title}>
                <div>
                    {editReasons ?
                        (<Popup component={EditReasons} endpoints={props.endpoints} data={props.data} setData={props.setData} type={props.type} close={() => {
                            setEditReasons(false)
                        }} />)
                        : ""}
                    {editPerTargetLimits ?
                        (<Popup component={EditPerTargetLimits} endpoints={props.endpoints} data={props.data} setData={props.setData} type={props.type} close={() => {
                            setEditPerTargetLimits(false)
                        }} />)
                        : ""}
                    {editColumnOrder ?
                        (<Popup component={EditColumnOrder} endpoints={props.endpoints} data={props.data} setData={props.setData} type={props.type} close={() => {
                            setEditColumnOrder(false)
                        }} />)
                        : ""}
                </div>
                <div className={styles.titleText}>Edit Exercise</div>
                <div className={styles.close} onClick={() => {
                    props.close()
                }}><i className="fas fa-times"></i></div>
            </div>
            <form>
                <div className={styles.body}>
                    <div className={styles.required}>REQUIRED FIELD *</div>
                    <div className={styles.content}>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>NAME <div className={styles.required}>*</div></div>
                            <input type="text" className={valid || name !== "" ? styles.default : styles.error} value={name} onChange={(event) => {
                                    setName(event.target.value)
                                }} autoFocus/>
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>TEAM</div>
                            <input type="text" className={styles.default} value={team} disabled />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>START DATE <div className={styles.required}>*</div></div>
                                <input type="date" className={valid || startDate !== "" ? styles.default : styles.error} value={startDate.slice(0, 10).replace(/[/]/g, "-")} onChange={(event) => {
                                        setStartDate(event.target.value)
                                    }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>END DATE <div className={styles.required}>*</div></div>
                                <input type="date" className={valid || endDate !== "" ? styles.default : styles.error} value={endDate.slice(0, 10).replace(/[/]/g, "-")} onChange={(event) => {
                                        setEndDate(event.target.value)
                                    }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>EXERCISE ID</div>
                            <input type="text" className={styles.default} value={props.data.ID} disabled />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.gridPlaceholder}></div>
                        </div>
                        <div className={styles.set} style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className={styles.inputTitle}>LIMIT MODE</div>
                            <div style={{ display: 'flex', gap: 48, alignItems: 'center', padding: '8px 0' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap' }}>
                                    <input type="radio" value="percent" checked={limitType === 'percent'} onChange={() => setLimitType('percent')} />
                                    % of territory
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap' }}>
                                    <input type="radio" value="static" checked={limitType === 'static'} onChange={() => setLimitType('static')} />
                                    Static count
                                </label>
                            </div>
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>{limitType === 'static' ? 'MAX # OF TERRITORY TARGETS TO RECLASSIFY' : 'MAX % OF TERRITORY TARGETS TO RECLASSIFY'} <div className={styles.required}>*</div></div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={valid ? styles.default : styles.error} value={maxChangesPerTerritory} onChange={(event) => {
                                setMaxChangesPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>{limitType === 'static' ? 'MAX # 🢁 PLANNED CALLS PER TERRITORY' : '% 🢁 PLANNED CALLS PER TERRITORY'} <div className={styles.required}>*</div></div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={valid ? styles.default : styles.error} value={maxCallsPerTerritory} onChange={(event) => {
                                setMaxCallsPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>{limitType === 'static' ? 'MIN # OF TERRITORY TARGETS TO RECLASSIFY' : 'MIN % OF TERRITORY TARGETS TO RECLASSIFY'} <div className={styles.required}>*</div></div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={valid ? styles.default : styles.error} value={minChangesPerTerritory} onChange={(event) => {
                                setMinChangesPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>{limitType === 'static' ? 'MIN # 🢃 PLANNED CALLS PER TERRITORY' : '% 🢃 PLANNED CALLS PER TERRITORY'} <div className={styles.required}>*</div></div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={valid ? styles.default : styles.error} value={minCallsPerTerritory} onChange={(event) => {
                                setMinCallsPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>MAX {limitType === 'static' ? '#' : '%'} OF TERRITORY UPGRADES 🢁</div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={styles.default} value={maxUpgradesPerTerritory} onChange={(event) => {
                                setMaxUpgradesPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>MAX {limitType === 'static' ? '#' : '%'} OF TERRITORY DOWNGRADES 🢃</div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={styles.default} value={maxDowngradesPerTerritory} onChange={(event) => {
                                setMaxDowngradesPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.reasonRow}>
                            <div className={styles.set}>
                                <div className={styles.inputTitle}></div>
                                <div id={styles.reasons}
                                    onClick={() => {
                                        setEditReasons(true)
                                    }
                                    }><i className="far fa-edit"></i>{`  EDIT REASONS`}</div>
                            </div>
                            <div className={styles.set}>
                                <div className={styles.inputTitle}></div>
                                <div id={styles.reasons}
                                    onClick={() => {
                                        setEditPerTargetLimits(true)
                                    }
                                    }><i className="far fa-edit"></i>{`  EDIT PER TARGET LIMITS`}</div>
                            </div>
                            <div className={styles.set}>
                                <div className={styles.inputTitle}></div>
                                <div id={styles.reasons}
                                    onClick={() => {
                                        setEditColumnOrder(true)
                                    }
                                    }><i className="far fa-edit"></i>{`  EDIT COLUMN ORDER`}</div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.buttonRow}>
                        <div id={styles.cancel}
                            onClick={() => {
                                props.close()
                            }
                        }>CANCEL</div>
                        <div type="submit" id={styles.submit} className={wiggle ? styles.Wiggle : ""} onClick={() => {
                                if (name !== "" && team !== "" && startDate !== "" && endDate !== "") {
                                    let temp = {
                                        name: name,
                                        team: team,
                                        startDate: startDate,
                                        endDate: endDate,
                                        id: props.data.ID,
                                        type: props.data.CUSTOMER_TYPE,
                                        maxChangesPerTerritory: maxChangesPerTerritory,
                                        minChangesPerTerritory: minChangesPerTerritory,
                                        maxCallsPerTerritory: maxCallsPerTerritory,
                                        minCallsPerTerritory: minCallsPerTerritory,
                                        maxUpgradesPerTerritory: maxUpgradesPerTerritory,
                                        maxDowngradesPerTerritory: maxDowngradesPerTerritory,
                                        limitType: limitType
                                    }
                                    Axios(props.endpoints.editExercise, temp, (data) => {
                                        props.setData(data)
                                        props.close()
                                    })
                                }
                                else {
                                    setWiggle(true)
                                    setValid(false)
                                    setTimeout(() => {
                                        setWiggle(false)
                                    }, 500);
                                }
                            }
                        }>SUBMIT</div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default EditExercise
